import { http } from 'interfaces'
import { type PersonAddress } from 'components'
import { type State } from 'components/us/common/state-select'
import {
  type ExecOrg,
  type ExecOrgRef
} from 'services/executives/executiveOrgLookupService'
import { type ExecRole } from 'services/lutValuesService'
import { type PersonBaseBasicInformation } from 'services/person/international/edit/personBasicInfoService'

export type { ExecOrg, ExecOrgRef, ExecRole }

export interface ExecutivePosition {
  id: number
  title: string
  org: ExecOrg
  execRole: ExecRole
  execRole2: ExecRole | null
  execRole3: ExecRole | null
  statusId: number
  state: State
  apptStartDate: string | null
  apptEndDate: string | null
  displayOrder: number
  person: PersonBaseBasicInformation
  typeId: number
  electDate: string | null
  electCode: string | null
  percentVote: number | null
  reelectYear: string | null
  termNumber: number | null
  cco: number | null
  nominateDate: string | null
  confirmDate: string | null
  levelId: number | null
  presidentId: number | null
  liaisonCode: 0 | 1 | 2 | 3
  addressId: number | null
  address?: PersonAddress | null
  responsibilities: number[]
  administrationIds: number[]
  vacant?: boolean
}

export interface ExecutiveStafferRole {
  id: number
  title: string
  displayOrder: number
  execRole: ExecRole
  position: Pick<ExecutivePosition, 'id' | 'title' | 'org' | 'state'>
}

export interface ExecutiveRolesForPerson {
  positions: ExecutivePosition[]
  stafferRoles: ExecutiveStafferRole[]
}

export async function getExecutiveRoles (personId: number): Promise<ExecutiveRolesForPerson> {
  const response = await http.get<ExecutiveRolesForPerson>(
    `/api/v1/us/person/${personId}/executive-roles/`
  )
  return response.data
}
